import { Routes } from '@angular/router';
import { PrivateDomainNotFoundComponent } from './components/private-domain-not-found/private-domain-not-found.component';
import { PrivateDomainAddComponent } from './containers/private-domain-add/private-domain-add.component';
import { PrivateDomainEditComponent } from './containers/private-domain-edit/private-domain-edit.component';
import { PrivateDomainComponent } from './containers/private-domain/private-domain.component';
import { PrivateDomainGuard } from './guards/private-domain.guard';

export const PRIVATE_DOMAIN_ROUTES: Routes = [
  {
    path: '',
    canActivate: [PrivateDomainGuard],
    data: {
      hosts: [
        'backoffice.au.apsisbeta.one',
        'backoffice.au-apac.apsisbeta.one',
      ],
    },
    children: [
      { path: '', component: PrivateDomainComponent },
      { path: 'add', component: PrivateDomainAddComponent },
      { path: 'edit/:accountId', component: PrivateDomainEditComponent },
    ],
  },
  { path: 'page-not-found', component: PrivateDomainNotFoundComponent },
];
